function getNextQuarterEnd(date) {
  let month = new Date(date).getUTCMonth();
  let year = new Date(date).getUTCFullYear();
  month += 3;
  if (month >= 12) {
    month -= 12;
    year++;
  }
  return new Date(year, month, 31).getTime();
}
function getNextMonth(dateTimestamp) {
  const date = new Date(dateTimestamp);
  const year = date.getFullYear();
  const month = date.getMonth();

  // Move to next month, handle December -> January
  const nextMonth = (month + 1) % 12;
  const nextYear = nextMonth === 0 ? year + 1 : year;
  return new Date(nextYear, nextMonth, 1).getTime();
}
function addForecast(chartObject) {
  if (forecastToPlot.length > 0) {
    const series = chartObject.chart.series[0];
		forecastToPlot.unshift(series.data[series.data.length - 1].options)
		let newforecastToPlot =  forecastToPlot.slice(0, 6);

		for (let i = 0; i < 2; i++) {
			const lastDate = newforecastToPlot[newforecastToPlot.length - 1].x;
			const nextMonthDate = getNextMonth(lastDate);

			newforecastToPlot.push({
				x: nextMonthDate,
				date: new Date(nextMonthDate).toISOString().slice(0, 10),
			});
		}
/*
    chartObject.chart.xAxis[0].addPlotLine({
  color: '#CDCDCD',
  width: 2,
  value: newforecastToPlot[0].x,
  dashStyle: 'Dash',
  label: {
    text: 'Forecast Start',
    style: { color: '#CDCDCD' },
    y: 15 
  }
});*/


    const forecast_options = {
      type: 'line',
      data: newforecastToPlot,
      id: 'forecast',
      color: '#CDCDCD',

    };

    if (chartObject.chart) {
      chartObject.chart.addSeries(forecast_options);
      chartObject.chart.update({
        xAxis: [{
          ordinal: false,
        }]
      });
    } else {
      console.error("Chart not initialized. Cannot add series.");
    }

    _th = chartObject;
  }
  return;
}
 
 //STATS
 
 function calcAvg(data) {
   return data.reduce((a, c) => a + c.y, 0) / data.length
 }
 
 function addAvg(axis, value) {
   axis.removePlotLine('avg')
   axis.addPlotLine({
     id: 'avg',
     value: value,
     enableMouseTracking: false,
     color: !IsDarkMode? 'rgb(51, 51, 51)' : 'rgb(211, 211, 211)',
     dashStyle: 'longdash',
     label: {
       text: 'MEAN',
       style: {
         color: !IsDarkMode? 'rgb(51, 51, 51)' : 'rgb(211, 211, 211)',
         fontSize: '10px',
         transform: 'translateX(-30%)'
       },
       align: 'right',
       useHTML: true
       },
     width: 1,
     zIndex: 1
   })
 }
 
 function calcSTD(data, avg) {
   return (data.reduce((a, c) => a + (c.y - avg)**2, 0) / data.length)**0.5
 }
 
 function addVariance(axis, avg, STD) {
   axis.removePlotBand('std')
   axis.addPlotBand({
     id: 'std',
     from: avg - STD,
     to: avg + STD,
     color: 'rgba(68, 170, 213, 0.1)',
     label: {
       text: 'VARIANCE',
       style: {
         color: !IsDarkMode? 'rgb(51, 51, 51)' : 'rgb(211, 211, 211)',
         fontSize: '10px',
         transform: 'translate(-8%, 50%)'
       },
       align: 'right',
       verticalAlign: 'top',
       useHTML: true
     },
     zIndex: 1
   })
 }
 
 function linearRegression(data) {
   function mean(values) {
     return values.reduce((acc, val) => acc + val, 0) / values.length;
   }
   const n = data.length;
   const xMean = mean(data.map(point => point.x));
   const yMean = mean(data.map(point => point.y));
   let numerator = 0;
   let denominator = 0;
   
   for (let i = 0; i < n; i++) {
     const xDiff = data[i].x - xMean;
     const yDiff = data[i].y - yMean;
     numerator += xDiff * yDiff;
     denominator += xDiff * xDiff;
   }
   
   const slope = numerator / denominator;
   const intercept = yMean - slope * xMean;
   const first_point = {x: data[0].x, y: slope * data[0].x + intercept}
   const time_step = data[data.length - 1].x - data[data.length - 2].x
   const last_point = {x: data[data.length - 1].x + time_step, y: slope * (data[data.length - 1].x + time_step) + intercept}
   return [first_point, last_point]
 }
 
 function addStats(chartObject) {
   if (chartObject.chart) {
   const statsSerie = chartObject.series[Object.keys(chartObject.series)[0]].config.data
   const avg = calcAvg(statsSerie.filter(el => el.y != null))
   const STD = calcSTD(statsSerie.filter(el => el.y != null), avg)
 
   addAvg(chartObject.chart.get('y_axis_main'), avg)
   addVariance(chartObject.chart.get('y_axis_main'), avg, STD)
   
   const trendline_data = linearRegression(statsSerie.filter(el => el.y != null))
   const trendline_obj = {
     name: 'stats_trendline',
     type: 'line',
     data: trendline_data,
     color: !IsDarkMode? 'rgb(51, 51, 51)' : 'rgb(211, 211, 211)',
     id: 'stats_trendline',
     lineWidth: 1,
     zIndex: 4,
     enableMouseTracking: false,
     states: {
       hover: {
         enabled: false
       }
     },
     turboThreshold: 1500
   }
   chartObject.chart.addSeries(trendline_obj);
 }
 }
 
 function removeStats(chartObject) {
   let removeStatsSeries = chartObject.chart.get('y_axis_main')
   removeStatsSeries.removePlotLine('avg')
   removeStatsSeries.removePlotLine('std')
   if(chartObject.chart.get('stats_trendline')){
     chartObject.chart.get('stats_trendline').remove(false);
   }
 }
 // Marktes tabs

	const tabLink = document.querySelector('#pagemenutabs');
	if(tabLink){
		tabLink.addEventListener('click', function(event) {
      _th.update("axisType", "auto-" + 'y_axis_main');
			if (event.target.hasAttribute('href') && event.target.getAttribute('href') === '#forecast') {
				if(isLoggedIn){
					chartState = 'forecast'
					$('.opt-percentage-y_axis_main').addClass('non-clickable');
					$('.opt-difference-y_axis_main').addClass('non-clickable');
					$('.iChart-menu2-bottom-cnt-horizontal a[data-span="5y"]').click();
				}
			}
			if (event.target.hasAttribute('href') && event.target.getAttribute('href') === '#historical' ) {
				if(chartState == 'forecast' || chartState == 'stats'){
					$('.opt-percentage-y_axis_main').removeClass('non-clickable');
					$('.opt-difference-y_axis_main').removeClass('non-clickable');
					_th.build(function () {
						updateChartMenu.call(_th);
					});
				}
				removeStats(_th)
				chartState = 'summary'
				console.log(chartState)
			}
			if (event.target.hasAttribute('href') && event.target.getAttribute('href') === '#stats') {
				chartState = 'stats'
				$('.opt-percentage-y_axis_main').addClass('non-clickable');
				$('.opt-difference-y_axis_main').addClass('non-clickable');
				console.log(chartState)
					_th.build(function () {
						updateChartMenu.call(_th);
					});
			}
		});
	}